import { Box } from '@mui/material'

import { MeasuresTab } from '../../types'

interface TabToggleProps {
  selectedTab: MeasuresTab
  onTabChange: (tab: MeasuresTab) => void
}

const TabToggle = ({ selectedTab, onTabChange }: TabToggleProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
        borderRadius: '12px',
        marginBottom: '16px',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '2px solid #F5F5F7',
          borderRadius: '12px',
          pointerEvents: 'none',
          zIndex: 0,
        },
      }}
    >
      <Box
        onClick={() => onTabChange(MeasuresTab.Overview)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === MeasuresTab.Overview ? '#181D29' : 'transparent',
          color: selectedTab === MeasuresTab.Overview ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Übersicht
      </Box>
      <Box
        onClick={() => onTabChange(MeasuresTab.Packages)}
        sx={{
          flex: 1,
          padding: '12px 16px',
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.1px',
          backgroundColor: selectedTab === MeasuresTab.Packages ? '#181D29' : 'transparent',
          color: selectedTab === MeasuresTab.Packages ? '#ffffff' : undefined,
          borderRadius: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          position: 'relative',
          zIndex: 1,
        }}
      >
        Pakete
      </Box>
    </Box>
  )
}

export default TabToggle
